var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElektrafiLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "white",
    stroke: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_929_5267",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_929_5267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0007 29.3337C11.0162 29.3337 5.33398 23.3524 5.33398 16.0003C5.33398 8.64828 11.0162 2.66699 18.0007 2.66699C23.6084 2.66699 28.0007 5.44128 28.0007 8.98278C28.0007 10.1523 27.5217 11.2378 26.6795 12.1676C27.5195 13.2974 28.0007 14.6062 28.0007 16.0003C28.0007 17.3945 27.5184 18.7033 26.6795 19.8331C27.5217 20.764 28.0007 21.8495 28.0007 23.0179C28.0007 26.5594 23.6084 29.3337 18.0007 29.3337ZM18.0007 4.0705C11.7518 4.0705 6.66733 9.42253 6.66733 16.0003C6.66733 22.5781 11.7518 27.9302 18.0007 27.9302C22.6984 27.9302 26.6673 25.681 26.6673 23.0179C26.6673 22.2518 26.3395 21.5196 25.7584 20.8658C23.924 22.6061 21.1273 23.7196 18.0007 23.7196C14.5795 23.7196 12.0007 22.2108 12.0007 20.2109C12.0007 18.2108 14.5795 16.7021 18.0007 16.7021C21.1162 16.7021 23.8584 17.5582 25.6796 18.9278C26.3106 18.0518 26.6673 17.0565 26.6673 16.0003C26.6673 14.9442 26.3106 13.9488 25.6796 13.0728C23.8595 14.4424 21.1173 15.2986 18.0007 15.2986C14.5795 15.2986 12.0007 13.7898 12.0007 11.7898C12.0007 9.78981 14.5795 8.281 18.0007 8.281C21.1273 8.281 23.924 9.39445 25.7584 11.1348C26.3395 10.481 26.6673 9.74886 26.6673 8.98278C26.6673 6.32078 22.6984 4.0705 18.0007 4.0705ZM18.0007 18.1056C15.3295 18.1056 13.334 19.2167 13.334 20.2109C13.334 21.205 15.3295 22.3161 18.0007 22.3161C20.6718 22.3161 23.1473 21.3991 24.7384 19.9687C23.134 18.8424 20.6862 18.1056 18.0007 18.1056ZM18.0007 9.68451C15.3295 9.68451 13.334 10.7957 13.334 11.7898C13.334 12.784 15.3295 13.8951 18.0007 13.8951C20.6718 13.8951 23.1351 13.1594 24.7384 12.0319C23.1473 10.6015 20.7173 9.68451 18.0007 9.68451Z",
    fill: "inherit",
    stroke: "inherit",
    strokeWidth: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElektrafiLogo);
export default __webpack_public_path__ + "static/media/ElektrafiLogo.af325430fab6c32b803575d84eeb193d.svg";
export { ForwardRef as ReactComponent };